import React, { useState } from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';
import ScrollReveal from '../components/ScrollReveal';

const STATUS_DATA = [
  { category: 'FREE FIRE MOBILE', name: 'Painel Android', status: 'UNDETECTED' },
  { category: 'FREE FIRE MOBILE', name: 'Painel iOS', status: 'UNDETECTED' },
  { category: 'FREE FIRE EMULADOR', name: 'Internal Core', status: 'UNDETECTED' },
  { category: 'FREE FIRE EMULADOR', name: 'Bypass 50 Players', status: 'UNDETECTED' },
];

const StatusBadge = ({ status }) => {
  const isGood = status === 'UNDETECTED';
  return (
    <div className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border ${
      isGood
        ? 'bg-green-500/10 border-green-500/30 text-green-400'
        : 'bg-yellow-500/10 border-yellow-500/30 text-yellow-400'
    }`}>
      {isGood ? <CheckCircle className="w-3.5 h-3.5" /> : <AlertCircle className="w-3.5 h-3.5" />}
      <span className="text-xs font-bold tracking-wider">{status}</span>
    </div>
  );
};

const Status = () => {
  const [filter, setFilter] = useState('All');
  const categories = ['All', ...new Set(STATUS_DATA.map(p => p.category))];

  const filtered = filter === 'All' ? STATUS_DATA : STATUS_DATA.filter(p => p.category === filter);

  return (
    <div className="min-h-screen bg-black py-8 sm:py-16 px-3 sm:px-6 pb-24 sm:pb-16">
      <div className="max-w-3xl mx-auto">
        <ScrollReveal direction="up">
          <div className="mb-8">
            <p className="text-gray-500 text-[10px] font-bold tracking-[0.2em] uppercase mb-2">DISPONIBILIDADE</p>
            <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2">Status dos Produtos</h1>
            <p className="text-gray-400 text-sm sm:text-base">Status atual dos nossos softwares</p>
          </div>
        </ScrollReveal>

        {/* Filter tabs */}
        <ScrollReveal direction="up" delay={100}>
          <div className="bg-gray-900/50 backdrop-blur-sm rounded-2xl p-3 sm:p-4 border border-gray-800/40 mb-6 sm:mb-8">
            <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
              {categories.map(cat => (
                <button
                  key={cat}
                  onClick={() => setFilter(cat)}
                  className={`flex-shrink-0 px-4 py-2 rounded-lg text-xs sm:text-sm font-bold transition-all ${
                    filter === cat
                      ? 'bg-white text-black shadow-lg'
                      : 'text-gray-400 hover:text-white hover:bg-gray-800/60'
                  }`}
                  data-testid={`status-filter-${cat}`}
                >
                  {cat === 'All' ? 'Todos' : cat.split(' ').slice(-1)[0]}
                </button>
              ))}
            </div>
          </div>
        </ScrollReveal>

        {/* Status cards */}
        <div className="space-y-4">
          {filtered.map((product, idx) => (
            <ScrollReveal key={product.name} direction="up" delay={idx * 80}>
              <div
                className="relative bg-gray-900/40 backdrop-blur-sm rounded-2xl p-5 sm:p-6 border border-gray-800/30 hover:border-gray-700/50 transition-all overflow-hidden group"
                data-testid={`status-card-${idx}`}
              >
                {/* Subtle particles */}
                <div className="absolute inset-0 pointer-events-none">
                  <div className="absolute top-1/4 right-1/3 w-1 h-1 bg-gray-600/40 rounded-full" />
                  <div className="absolute top-1/2 right-1/4 w-1.5 h-1.5 bg-gray-600/30 rounded-full" />
                  <div className="absolute bottom-1/3 left-1/3 w-1 h-1 bg-gray-600/40 rounded-full" />
                  <div className="absolute top-1/3 left-1/2 w-1 h-1 bg-gray-600/30 rounded-full" />
                </div>

                <div className="relative flex items-center justify-between">
                  <div>
                    <p className="text-gray-500 text-[10px] sm:text-xs font-bold tracking-[0.15em] uppercase mb-1">{product.category}</p>
                    <h3 className="text-white text-lg sm:text-xl font-bold">{product.name}</h3>
                  </div>
                  <StatusBadge status={product.status} />
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>

        {/* Summary */}
        <ScrollReveal direction="up" delay={300}>
          <div className="mt-8 bg-green-500/5 border border-green-500/20 rounded-2xl p-5 sm:p-6 text-center">
            <div className="flex items-center justify-center gap-2 mb-2">
              <CheckCircle className="w-5 h-5 text-green-500" />
              <span className="text-green-400 font-bold text-sm sm:text-base">Todos os sistemas operacionais</span>
            </div>
            <p className="text-gray-400 text-xs sm:text-sm">Ultima verificacao: hoje</p>
          </div>
        </ScrollReveal>
      </div>
    </div>
  );
};

export default Status;
